import { useTranslation } from 'react-i18next';
import {
  PHONE_COUNTRIES,
  bookingPhoneDigits,
  phoneCountryLabel,
  type PhoneCountryIso,
} from '@cafe-pos/shared';

export function PhoneCountryInput({
  iso,
  national,
  onChange,
  locale,
  className,
  inputClassName,
}: {
  iso: string;
  national: string;
  onChange: (next: { iso: PhoneCountryIso; national: string }) => void;
  locale: string;
  className?: string;
  inputClassName?: string;
}) {
  const { t } = useTranslation();
  return (
    <div className={className ?? 'bookings-phone-input'}>
      <select
        className="bookings-phone-country"
        value={iso}
        aria-label={t('common.countryCode')}
        onChange={(e) =>
          onChange({ iso: e.target.value as PhoneCountryIso, national })
        }
      >
        {PHONE_COUNTRIES.map((c) => (
          <option key={c.iso} value={c.iso}>
            {c.iso === iso ? `+${c.dial}` : phoneCountryLabel(c.iso, locale)}
          </option>
        ))}
      </select>
      <input
        className={inputClassName}
        type="tel"
        inputMode="numeric"
        pattern="[0-9]*"
        autoComplete="tel-national"
        value={national}
        onChange={(e) =>
          onChange({
            iso: iso as PhoneCountryIso,
            national: bookingPhoneDigits(e.target.value),
          })
        }
      />
    </div>
  );
}
